import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Ind_Activity from './views/ind_activity.js';
import Unsubscribe from './views/unsubscribe.js';
import Broad_Camp_Intel from './views/broad_camp_intel.js';
import Optout from './views/optout.js';
import ProfileUpdate from './views/profile_update.js';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

const NotFound = () => (
  <div>
    <h3>404 page not found</h3>
    <p>We are sorry but the page you are looking for does not exist.</p>
  </div>
);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wizardPage : props.wizardPage,
      bin_page : props.bin_page,
      profile : props.profile
    };
  }

  componentDidMount() {
  }

  async getParams() {
  }

  render() {
    let { wizardPage, bin_page, profile } = this.state;
    let render_page = '';
    if ( wizardPage !== 'None' ) {
      switch (wizardPage){
        case 'broadcast_intelligence.php':
          render_page = <Route path="/suite4sf/common/php/reg_wizard.php" component={Broad_Camp_Intel} />;
          break;
        case 'campaign_intelligence.php':
          render_page = <Route path="/suite4sf/common/php/reg_wizard.php" component={Broad_Camp_Intel} />;
          break;
        case 'ind_activity.php':
          render_page = <Route path="/suite4sf/common/php/reg_wizard.php" component={Ind_Activity} />;
          break;
        default:
          render_page = <Route path="*" component={NotFound} status={404} />;
      }
    } else if (bin_page !== 'None' && bin_page !== null) {
      switch (bin_page) {
        case 'unsub.php':
          render_page = <Route path="/suite4sf/email/bin/unsub.php" component={Unsubscribe} />;
          break;
        case 'optout.php':
          render_page = <Route path="/suite4sf/email/bin/optout.php" component={Optout} />;
          break;
        default:
          render_page = <Route path="*" component={() => window.location.href = `https://suite.targetx.com${window.location.pathname}${window.location.search}${window.location.hash}` } />;
      }
    } else if (profile !== 'None' && profile !== null) {
      render_page = <Route path="/profile/:profile" ><ProfileUpdate profile={profile} /></Route>;
    } else {
      render_page = <Route path="*" component={() => window.location.href = `https://suite.targetx.com${window.location.pathname}${window.location.search}${window.location.hash}` } />;
    }
    return (
      <Router>
        <div className="common">
          <div className="App">
            {render_page}
          </div>
        </div>
      </Router>
    );
  }
}

App.propTypes = {
  wizardPage: PropTypes.string,
  bin_page: PropTypes.string,
  profile: PropTypes.string
};

export default App;



// WEBPACK FOOTER //
// ./src/client/App.js